<template>
  <popup>
    <template #title>안내</template>
    <template #content>
      고객님께서는 BMW Plus에서 가입된 BMW ServiceCare+ 가입이력이 있습니다.
      BMW Vantage앱에서 원활한 서비스 제공을 위해 이관등록을 안내 드립니다.<br><br>

      '이관등록하기' 화면을 통해 BMW Vantage의 계정으로 이관등록이 가능합니다.
    </template>
    <template #button>
      <span><a @click="move(false)">닫기</a></span>
      <span><a @click="move(true)" class="fCol1">이관등록하기</a></span>
    </template>
  </popup>
</template>
<script>
import Popup from './Popup.vue';
export default {
  components: {
    Popup,
  },
  methods:{
    move(oas = false){
      this.$store.commit('setPopup401', false);
      if(oas) location.href = this.$store.state.host.vtg + '?redirectType=app&redirectUrl=combine&parameter=oas'//vtg login 으로 이동
      else if(this.$route.path != '/') this.$router.push('/'); //main으로 이동 (main은 로근이 필요하지 않다.)
    },
  }
}
</script>

<style lang="css" scoped></style>